import { NextResponse } from "next/server"
import {
  buildAdminAjaxUrl,
  type CompleteTriiboRegistrationInput,
  type CompleteTriiboRegistrationResponse,
  resolveWordPressOrigin,
} from "@/api/auth"
import { env } from "@/env"
import { getWooCommerceCustomer } from "@/services/woo-commerce-service"
import {
  decodeWordPressLoggedInCookie,
  postAdminAjax,
} from "@/services/wordpress-service"
import { setSession } from "~/services/auth-service"

const toUrlEncodedBody = (input: Record<string, string>): URLSearchParams => {
  const payload = new URLSearchParams()

  for (const [key, value] of Object.entries(input)) {
    payload.set(key, value)
  }

  return payload
}

export const POST = async (request: Request) => {
  const body = (await request.json()) as CompleteTriiboRegistrationInput
  const origin = resolveWordPressOrigin(env.WP_API_URL)
  const endpoint = buildAdminAjaxUrl(origin)

  if (!(body.cellphone && body.email && body.password)) {
    return NextResponse.json(
      {
        success: false,
        error: {
          code: 400,
          message: "Cellphone, email e password sao obrigatorios.",
        },
      },
      { status: 400 }
    )
  }

  try {
    const { data, cookies } = await postAdminAjax(
      endpoint,
      toUrlEncodedBody({
        action: "tal_find_user",
        cellphone: body.cellphone,
        email: body.email,
        password: body.password,
        terms: `${body.terms}`,
        triiboId: body.triiboId ?? "",
        ckt: `${body.ckt ?? false}`,
      })
    )

    const response = data as CompleteTriiboRegistrationResponse
    const sessionCookie = cookies?.trim() || null

    if (response.success) {
      if (!sessionCookie) {
        return NextResponse.json(
          {
            success: false,
            error: {
              code: "AUTH_COOKIE_MISSING",
              message: "Nao foi possivel criar sessao autenticada.",
            },
          },
          { status: 502 }
        )
      }

      const wpUser = decodeWordPressLoggedInCookie(sessionCookie)
      const customer = wpUser
        ? await getWooCommerceCustomer(wpUser.username)
        : null

      let sessionUser: { id: string | number; name: string; email: string }

      if (customer) {
        sessionUser = {
          id: customer.id,
          name: customer.name,
          email: customer.email,
        }
      } else if (wpUser) {
        sessionUser = {
          id: wpUser.username,
          name: wpUser.username.split("@")[0] ?? "Cliente",
          email: wpUser.username,
        }
      } else {
        sessionUser = {
          id: body.email,
          name: body.email.split("@")[0] ?? "Cliente",
          email: body.email,
        }
      }

      await setSession({
        wordpressSessionCookie: sessionCookie,
        user: sessionUser,
      })

      return NextResponse.json({ ...response, redirect: "/" })
    }

    return NextResponse.json(response)
  } catch (error) {
    const message =
      error instanceof Error
        ? error.message
        : "Falha ao completar cadastro Triibo."

    return NextResponse.json(
      { success: false, error: { code: 500, message } },
      { status: 500 }
    )
  }
}
